import {DomainGraphType, CoreObject} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import EntityStore from 'stores/EntityStore';
import * as net from 'util/Net';

function getIds(items: Array<CoreObject>): Array<string> {
  return items.map(({id}) => id);
}

export function starItems(items: Array<CoreObject>): Promise<{}> {
  return net.postJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.STAR),
    data: {objectIds: getIds(items), userId: EntityStore.currentUser().id},
  });
}

export function unstarItems(items: Array<CoreObject>): Promise<{}> {
  return net.deletePromise({
    url: getApiBaseForObjectType(DomainGraphType.STAR),
    data: {objectIds: getIds(items), userId: EntityStore.currentUser().id},
  });
}
